import { Locale, localeRuleset } from '../ruleset/locale';
import { PetStatusNotification } from '../buruburu/petChatbot';

export type CreativeText = {
  id: string;
  cta: string;
  text: string;
};

type ReplicantTextConfig = {
  [lang: string]: {
    status: Record<PetStatusNotification, { text: string }>;
    energy: Record<'full', { text: string }>;
    visit: Record<'finish', { text: string }>;
    duo: Record<
      'invite' | 'expiration' | 'bubble' | 'response' | 'reminder',
      { text: string }
    >;
  };
};

function getConfig(): ReplicantTextConfig {
  return {
    en: {
      status: {
        dirty: { text: 'Maybe I should take a bath soon.' },
        hungry: { text: 'I’m a little bit hungry now…' },
        lonely: { text: 'I‘m feeling lonely. Will you come visit me?' },
        pee: { text: 'I think I need to go to the bathroom.' },
        evolving: { text: 'I feel like my body is getting all tingly…' },
        scared: { text: 'I’m scared… Help me…' },
        sick: { text: 'I feel sick. Please help me' },
        tooth_decay: { text: 'My teeth hurt. What is this?' },
        very_dirty: { text: 'I‘m itchy. I want to take a bath!' },
        very_hungry: { text: 'I’m starving…' },
        very_lonely: {
          text: 'I’m super lonely. Can you come and play with me?',
        },
        very_pee: { text: 'I can’t hold it anymore… Bathroom…' },
        dead: { text: 'Will you come to see me?' },
        dying: { text: 'Help me...' },
      },
      energy: {
        full: { text: 'Energy is fully charged!' },
      },
      visit: {
        finish: { text: 'I just played with {name}!' },
      },
      duo: {
        invite: { text: '{name} just\ninvited you to form a duo!' },
        reminder: { text: '{name} is\nwaiting for your response!' },
        response: { text: '{name} is responding!' },
        expiration: { text: 'Please respond within {hh} hours {mm} minutes!' },
        bubble: { text: 'I took it seriously' },
      },
    },
    ja: {
      status: {
        dirty: { text: 'そろそろお風呂入りたいかも…' },
        hungry: { text: 'ちょっとおなか空いてきたなあ…。' },
        lonely: { text: 'なんだかさみしくなっちゃった。遊びに来て？' },
        pee: { text: 'そろそろトイレに行きたいかも…' },
        evolving: { text: 'なんだか、からだがムズムズする…' },
        scared: { text: 'こわいー。こわいー。たすけてー' },
        sick: { text: 'うーん…。くるしい…。たすけて…' },
        tooth_decay: { text: '歯がいたいよー。なにこれー？' },
        very_dirty: { text: 'かゆいよー。お風呂入りたいー' },
        very_hungry: { text: 'ひもじいよー。死んじゃうよー' },
        very_lonely: { text: 'さーみーしーいー…。きて…？' },
        very_pee: { text: 'もぅ…限界…。トイレ…' },
        dead: { text: 'さいごに会いに来てほしいな' },
        dying: { text: 'たすけて…死んじゃう…' },
      },
      energy: {
        full: { text: 'エネルギー満タンだよ！' },
      },
      visit: {
        finish: { text: '{name}\nとあそんだよ！' },
      },

      duo: {
        invite: { text: '{name}から\nコンビ結成を申し込まれたよ！' },
        reminder: { text: '{name} が\nお返事を待ってるよ！' },
        response: { text: '{name}が\nお返事しますって！' },
        expiration: { text: '{hh}時間{mm}分以内にお返事してね' },
        bubble: { text: '真剣に考えました' },
      },
    },
  };
}

export function getLocaleConfig(locale: string) {
  const config = getConfig();
  const lang = config[locale] ? locale : localeRuleset.fallbackLocale;
  return config[lang];
}

export function getPetStatusText(
  locale: Locale,
  status: PetStatusNotification,
) {
  const localeConfig = getLocaleConfig(locale);
  const creative = localeConfig.status[status];

  return creative?.text;
}
